import AutoAwesomeMotionIcon from '@mui/icons-material/AutoAwesomeMotion';
import RefreshIcon from '@mui/icons-material/Refresh';
import { Box, Button, IconButton, Stack, Tooltip, Typography } from '@mui/material';
import { useSetAtom } from 'jotai';
import { bulkTearsheetGenerationModalOpenState } from './bulkTearsheetGenerationState';
import { BulkTearsheetGenerationModal } from './BulkTearsheetGenerationModal';

interface BulkTearsheetGenerationProps {
  onRefresh?: () => void;
}

export function BulkTearsheetGeneration({ onRefresh }: BulkTearsheetGenerationProps) {
  return (
    <Box width='100%'>
      <BulkTearsheetGenerationModal onRefresh={onRefresh} />
      <Typography color='text.primary' component='section' width='100%'>
        <Stack direction='row' alignItems='center' justifyContent='space-between' mb='1rem'>
          <Typography variant='body2' color='text.secondary'>
            Generate tearsheets in bulk for selected companies and funds.
          </Typography>
          <Stack direction='row' spacing={1}>
            <BulkGenerateButton />
            {onRefresh && (
              <Tooltip title='Refresh tearsheets list'>
                <IconButton color='secondary' onClick={onRefresh} size='medium'>
                  <RefreshIcon />
                </IconButton>
              </Tooltip>
            )}
          </Stack>
        </Stack>
      </Typography>
    </Box>
  );
}

function BulkGenerateButton() {
  const setModalOpen = useSetAtom(bulkTearsheetGenerationModalOpenState);
  return (
    <Button
      size='medium'
      variant='contained'
      color='secondary'
      startIcon={<AutoAwesomeMotionIcon />}
      onClick={() => setModalOpen(true)}
    >
      Bulk Generate
    </Button>
  );
}
